export default {
  "NIST-800-63B": {
    id: "NIST-800-63B",
    displayName: "NIST 800-63B",
    name: "NIST 800-63B",
    url: "https://pages.nist.gov/800-63-3/sp800-63b.html",
    controls: {
      "5.1.1.1": {
        url: "https://pages.nist.gov/800-63-3/sp800-63b.html#memsecret",
      },
      "5.1.1.2": {
        url: "https://pages.nist.gov/800-63-3/sp800-63b.html#aal",
      },
      "5.2.2": {
        url: "https://pages.nist.gov/800-63-3/sp800-63b.html#throttle",
      },
    },
  },
  "SOC2": {
    id: "SOC2",
    displayName: "SOC 2",
    name: "SOC 2",
    url: "https://www.aicpa-cima.com/resources/landing/system-and-organization-controls-soc-suite-of-services",
    controls: {
      "CC6.1": {
        url: "https://www.aicpa-cima.com/resources/landing/system-and-organization-controls-soc-suite-of-services",
      },
      "CC6.2": {
        url: "https://www.aicpa-cima.com/resources/landing/system-and-organization-controls-soc-suite-of-services",
      },
      "CC6.3": {
        url: "https://www.aicpa-cima.com/resources/landing/system-and-organization-controls-soc-suite-of-services",
      },
      "CC6.6": {
        url: "https://www.aicpa-cima.com/resources/landing/system-and-organization-controls-soc-suite-of-services",
      },
      "CC6.7": {
        url: "https://www.aicpa-cima.com/resources/landing/system-and-organization-controls-soc-suite-of-services",
      },
    },
  },
  "HIPAA": {
    id: "HIPAA",
    displayName: "HIPAA",
    name: "HIPAA",
    url: "https://www.ecfr.gov/current/title-45/subtitle-A/subchapter-C/part-164/subpart-C/section-164.312",
    controls: {
      "164.312(a)(1)": {
        url: "https://www.ecfr.gov/current/title-45/subtitle-A/subchapter-C/part-164/subpart-C/section-164.312",
      },
      "164.312(b)": {
        url: "https://www.ecfr.gov/current/title-45/subtitle-A/subchapter-C/part-164/subpart-C/section-164.312",
      },
      "164.312(d)": {
        url: "https://www.ecfr.gov/current/title-45/subtitle-A/subchapter-C/part-164/subpart-C/section-164.312",
      },
      "164.312(e)(1)": {
        url: "https://www.ecfr.gov/current/title-45/subtitle-A/subchapter-C/part-164/subpart-C/section-164.312",
      },
    },
  },
  "PCI-DSS-v4": {
    id: "PCI-DSS-v4",
    displayName: "PCI-DSS v4.0",
    name: "PCI-DSS v4.0",
    url: "https://www.pcisecuritystandards.org/document_library/",
    controls: {
      "8.3": {
        url: "https://www.pcisecuritystandards.org/document_library/",
      },
      "8.4": {
        url: "https://www.pcisecuritystandards.org/document_library/",
      },
    },
  },
  "OKTA-BASELINE": {
    id: "OKTA-BASELINE",
    displayName: "Okta Baseline",
    name: "Okta Baseline",
    url: null,
    composedOf: ["NIST-800-63B"],
    controls: {},
  },
};

